<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div
            class="card-header pb-0 d-flex justify-content-between align-items-center"
          >
            <h6>收款設定</h6>
            <button class="btn btn-sm btn-success mb-0" @click="openModal()">
              新增收款方式
            </button>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      圖片
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      名稱
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      代碼
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      排序
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      狀態
                    </th>
                    <th class="text-secondary opacity-7"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="method in methods" :key="method.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <img
                          :src="
                            method.image || 'https://via.placeholder.com/150'
                          "
                          class="avatar avatar-lg me-3 border-radius-lg"
                          alt="method"
                          style="object-fit: contain; background: #f8f9fa"
                        />
                      </div>
                    </td>
                    <td>
                      <p class="text-sm font-weight-bold mb-0">
                        {{ method.name }}
                      </p>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">
                        {{ method.code }}
                      </p>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">{{
                        method.sort_order
                      }}</span>
                    </td>
                    <td class="align-middle text-center">
                      <soft-badge
                        :color="method.is_active ? 'success' : 'secondary'"
                        variant="gradient"
                        size="sm"
                      >
                        {{ method.is_active ? "啟用" : "停用" }}
                      </soft-badge>
                    </td>
                    <td class="align-middle">
                      <a
                        href="javascript:;"
                        class="text-secondary font-weight-bold text-xs me-3"
                        @click="openModal(method)"
                      >
                        編輯
                      </a>
                      <a
                        href="javascript:;"
                        class="text-danger font-weight-bold text-xs"
                        @click="deleteMethod(method.id)"
                      >
                        刪除
                      </a>
                    </td>
                  </tr>
                  <tr v-if="methods.length === 0">
                    <td colspan="6" class="text-center py-4 text-secondary">
                      暫無資料
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      v-if="showModal"
      class="modal fade show d-block"
      style="background: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ isEditing ? "編輯收款方式" : "新增收款方式" }}
            </h5>
            <button type="button" class="btn-close" @click="closeModal">
              X
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="saveMethod">
              <div class="mb-3">
                <label class="form-label">名稱 (必填)</label>
                <soft-input
                  v-model="form.name"
                  placeholder="例如：銀行轉帳、Line Pay"
                  required
                />
              </div>
              <div class="mb-3">
                <label class="form-label">代碼 (必填，唯一)</label>
                <soft-input
                  v-model="form.code"
                  placeholder="例如：bank_transfer_01"
                  required
                />
              </div>
              <div class="mb-3">
                <label class="form-label">銀行代碼 (選填)</label>
                <soft-input v-model="form.bank_code" placeholder="例如：822" />
              </div>
              <div class="mb-3">
                <label class="form-label">銀行帳號 (選填)</label>
                <soft-input
                  v-model="form.bank_account"
                  placeholder="例如：1234567890123"
                />
              </div>
              <div class="mb-3">
                <label class="form-label">說明文字 (選填)</label>
                <textarea
                  class="form-control"
                  rows="3"
                  v-model="form.description"
                ></textarea>
              </div>
              <div class="mb-3">
                <label class="form-label">圖片 (QR Code 等)</label>
                <input
                  type="file"
                  class="form-control"
                  @change="handleFileUpload"
                  accept="image/*,.heic,.heif"
                />
                <div v-if="form.image_preview || form.image_url" class="mt-2">
                  <img
                    :src="form.image_preview || form.image_url"
                    class="img-fluid"
                    style="max-height: 150px"
                  />
                </div>
              </div>
              <div class="mb-3">
                <label class="form-label">排序</label>
                <soft-input v-model="form.sort_order" type="number" />
              </div>
              <div class="form-check form-switch ps-0">
                <input
                  class="form-check-input ms-auto"
                  type="checkbox"
                  id="isActive"
                  v-model="form.is_active"
                />
                <label
                  class="form-check-label text-body ms-3 text-truncate w-80 mb-0"
                  for="isActive"
                  >啟用</label
                >
              </div>

              <!-- CTBC Settings -->
              <div
                v-if="form.code === 'ctbc_credit_card'"
                class="mt-3 border-top pt-3"
              >
                <h6>中國信託設定 (CTBC Settings)</h6>
                <div class="mb-3">
                  <label class="form-label">特店網站專用代號 (merID)</label>
                  <soft-input
                    v-model="form.settings.mer_id"
                    placeholder="如 327"
                  />
                </div>
                <div class="mb-3">
                  <label class="form-label">特店代號 (MerchantID)</label>
                  <soft-input v-model="form.settings.merchant_id" />
                </div>
                <div class="mb-3">
                  <label class="form-label">終端機代號 (TerminalID)</label>
                  <soft-input v-model="form.settings.terminal_id" />
                </div>
                <div class="mb-3">
                  <label class="form-label">特店名稱 (MerchantName)</label>
                  <soft-input v-model="form.settings.merchant_name" />
                </div>
                <div class="mb-3">
                  <label class="form-label">押碼鍵值 (Key)</label>
                  <soft-input v-model="form.settings.key" type="password" />
                </div>
                <!-- Environment Switch -->
                <div class="form-check form-switch ps-0 mt-3">
                  <input
                    class="form-check-input ms-auto"
                    type="checkbox"
                    id="isProduction"
                    v-model="form.settings.is_production"
                  />
                  <label
                    class="form-check-label text-body ms-3 text-truncate w-80 mb-0"
                    for="isProduction"
                  >
                    正式環境 (Production)
                  </label>
                </div>
              </div>

              <!-- LINE Pay Settings -->
              <div v-if="form.code === 'line_pay'" class="mt-3 border-top pt-3">
                <h6>LINE Pay 設定</h6>
                <div class="mb-3">
                  <label class="form-label">Channel ID</label>
                  <soft-input v-model="form.settings.channel_id" />
                </div>
                <div class="mb-3">
                  <label class="form-label">Channel Secret</label>
                  <soft-input
                    v-model="form.settings.channel_secret"
                    type="password"
                  />
                </div>
                <!-- Environment Switch -->
                <div class="form-check form-switch ps-0 mt-3">
                  <input
                    class="form-check-input ms-auto"
                    type="checkbox"
                    id="isProductionLine"
                    v-model="form.settings.is_production"
                  />
                  <label
                    class="form-check-label text-body ms-3 text-truncate w-80 mb-0"
                    for="isProductionLine"
                  >
                    正式環境 (Production)
                  </label>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">
              取消
            </button>
            <button type="button" class="btn btn-primary" @click="saveMethod">
              儲存
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SoftBadge from "@/components/SoftBadge.vue";
import SoftInput from "@/components/SoftInput.vue";
import request from "@/utils/request";
import Swal from "sweetalert2";

export default {
  name: "PaymentSettings",
  components: {
    SoftBadge,
    SoftInput,
  },
  data() {
    return {
      methods: [],
      showModal: false,
      isEditing: false,
      form: {
        id: null,
        name: "",
        code: "",
        bank_code: "",
        bank_account: "",
        description: "",
        sort_order: 0,
        is_active: true,
        image_file: null,
        image_preview: null,
        image_url: null,
        settings: {
          merchant_id: "",
          terminal_id: "",
          merchant_name: "",
          key: "",
          is_production: false,
        },
      },
    };
  },
  methods: {
    async fetchMethods() {
      try {
        const response = await request.get("/api/admin/payment-methods");
        this.methods = response.data.data;
      } catch (error) {
        console.error("Failed to fetch methods", error);
      }
    },
    openModal(method = null) {
      if (method) {
        this.isEditing = true;
        const settings = method.settings || {};
        this.form = {
          id: method.id,
          name: method.name,
          code: method.code,
          bank_code: method.bank_code || "",
          bank_account: method.bank_account || "",
          description: method.description,
          sort_order: method.sort_order,
          is_active: !!method.is_active,
          image_url: method.image,
          image_file: null,
          image_preview: null,
          settings: {
            merchant_id: settings.merchant_id || "",
            terminal_id: settings.terminal_id || "",
            merchant_name: settings.merchant_name || "",
            key: settings.key || "",
            is_production: String(settings.is_production) === "true",
            mer_id: settings.mer_id || "",
            channel_id: settings.channel_id || "",
            channel_secret: settings.channel_secret || "",
          },
        };
      } else {
        this.isEditing = false;
        this.form = {
          id: null,
          name: "",
          code: "",
          bank_code: "",
          bank_account: "",
          description: "",
          sort_order: 0,
          is_active: true,
          image_file: null,
          image_preview: null,
          image_url: null,
          settings: {
            merchant_id: "",
            terminal_id: "",
            merchant_name: "",
            key: "",
            is_production: false,
            mer_id: "",
            channel_id: "",
            channel_secret: "",
          },
        };
      }
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.form.image_file = file;
        this.form.image_preview = URL.createObjectURL(file);
      }
    },
    async saveMethod() {
      if (!this.form.name || !this.form.code) {
        Swal.fire("錯誤", "請填寫名稱與代碼", "error");
        return;
      }

      const formData = new FormData();
      formData.append("name", this.form.name);
      formData.append("code", this.form.code);
      if (this.form.bank_code)
        formData.append("bank_code", this.form.bank_code);
      if (this.form.bank_account)
        formData.append("bank_account", this.form.bank_account);
      if (this.form.description)
        formData.append("description", this.form.description);
      formData.append("sort_order", this.form.sort_order);
      formData.append("is_active", this.form.is_active ? 1 : 0);

      // Append settings as JSON string or individual fields?
      // Since model casts to array, Laravel usually expects array input.
      // FormData doesn't support array directly well unless indices used settings[key].
      // Or send as JSON string and decode in controller?
      // Let's iterate.
      if (this.form.settings) {
        // Send as JSON string to ensure complex structure is preserved correctly
        formData.append("settings", JSON.stringify(this.form.settings));
      }

      if (this.form.image_file) {
        formData.append("image", this.form.image_file);
      }

      try {
        if (this.isEditing) {
          // Should use PUT but FormData with file requires special handling in Laravel/PHP (method spoofing) or just POST
          // Usually POST with _method=PUT or just dedicated POST endpoint.
          // Or standard axios post is fine if backend handles it?
          // Laravel resource update expects PUT/PATCH. PHP cannot parse multipart/form-data for PUT requests natively.
          // Workaround: POST with _method = PUT
          formData.append("_method", "PUT");
          await request.post(
            `/api/admin/payment-methods/${this.form.id}`,
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );
        } else {
          await request.post("/api/admin/payment-methods", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
        }
        Swal.fire("成功", "儲存成功", "success");
        this.closeModal();
        this.fetchMethods();
      } catch (error) {
        console.error(error);
        Swal.fire("錯誤", error.response?.data?.message || "儲存失敗", "error");
      }
    },
    async deleteMethod(id) {
      if (!confirm("確定要刪除？")) return;
      try {
        await request.delete(`/api/admin/payment-methods/${id}`);
        this.fetchMethods();
        Swal.fire("成功", "已刪除", "success");
      } catch (error) {
        Swal.fire("錯誤", "刪除失敗", "error");
      }
    },
  },
  async created() {
    this.fetchMethods();
  },
};
</script>
